import { createContext } from 'react';

const InscriptionsContext = createContext();

export default InscriptionsContext;